import React from 'react'
import { Row, Col } from 'rsuite'
import moment from 'moment'
import { getValueFromOptions, maskIdCard } from '../../../utils/dataUtil'

export default function WorkingGroupView({ data }) {
  const honorificValue = getValueFromOptions(data?.honorific?.options, data?.honorific?.value)

  let nationalityValue
  if (data?.nationality?.value == 2) {
    nationalityValue = data.nationality.inputOther?.value
  } else {
    nationalityValue = getValueFromOptions(data?.nationality?.options, data?.nationality?.value)
  }

  let fullName
  if (honorificValue && data?.firstName?.value && data?.lastName?.value) {
    fullName = honorificValue + ' ' + data.firstName.value + ' ' + data.lastName.value
  }

  return (
    <>
      <Row>
        <Col xs={24} sm={12} md={8} lg={8}>
          <span>
            &#9679; <b>{fullName || '-ไม่ระบุ-'}</b>
          </span>
        </Col>
        <Col xs={24} sm={12} md={16} lg={16}>
          <span>
            &#9679; {`${data?.idNumber?.label} : `}
            <b>{`${maskIdCard(data?.idNumber?.value) || 'ไม่ระบุ'}`}</b>
          </span>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={12} md={8} lg={8}>
          <span>
            &#9679; {`${data?.nationality?.label} : `}
            <b>{`${nationalityValue || '-ไม่ระบุ-'}`}</b>
          </span>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8}>
          <span>
            &#9679; {`${data?.dateOfBirth?.label} : `}
            <b>{`${
              (data?.dateOfBirth?.value && moment(data?.dateOfBirth?.value).format('DD/MM/YYYY')) ||
              '-ไม่ระบุ-'
            }`}</b>
          </span>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={12} md={8} lg={8}>
          <span>
            &#9679; {`${data?.telephone?.label} : `}
            <b>{`${data?.telephone?.value || '-ไม่ระบุ-'}`}</b>
          </span>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8}>
          <span>
            &#9679; {`${data?.mobile?.label} : `}
            <b>{`${data?.mobile?.value || '-ไม่ระบุ-'}`}</b>
          </span>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8}>
          <span>
            &#9679; {`${data?.fax?.label} : `}
            <b>{`${data?.fax?.value || '-ไม่ระบุ-'}`}</b>
          </span>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={12} md={8} lg={8}>
          <span>
            &#9679; {`${data?.email?.label} : `}
            <b>{`${data?.email?.value || '-ไม่ระบุ-'}`}</b>
          </span>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8}>
          <span>
            &#9679; {`${data?.lineId?.label} : `}
            <b>{`${data?.lineId?.value || '-ไม่ระบุ-'}`}</b>
          </span>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={12} md={8} lg={8}>
          <span>
            &#9679; {`${data?.buildingName?.label} : `}
            <b>{`${data?.buildingName?.value || '-ไม่ระบุ-'}`}</b>
          </span>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8}>
          <span>
            &#9679; {`${data?.roomNumber?.label} : `}
            <b>{`${data?.roomNumber?.value || '-ไม่ระบุ-'}`}</b>
          </span>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8}>
          <span>
            &#9679; {`${data?.houseNumber?.label} : `}
            <b>{`${data?.houseNumber?.value || '-ไม่ระบุ-'}`}</b>
          </span>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8}>
          <span>
            &#9679; {`${data?.villageNumber?.label} : `}
            <b>{`${data?.villageNumber?.value || '-ไม่ระบุ-'}`}</b>
          </span>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8}>
          <span>
            &#9679; {`${data?.lane?.label} : `}
            <b>{`${data?.lane?.value || '-ไม่ระบุ-'}`}</b>
          </span>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8}>
          <span>
            &#9679; {`${data?.villageName?.label} : `}
            <b>{`${data?.villageName?.value || '-ไม่ระบุ-'}`}</b>
          </span>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8}>
          <span>
            &#9679; {`${data?.road?.label} : `}
            <b>{`${data?.road?.value || '-ไม่ระบุ-'}`}</b>
          </span>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8}>
          <span>
            &#9679; {`${data?.location?.subDistrictLabel} : `}
            <b>{`${data?.location?.subDistrict || '-ไม่ระบุ-'}`}</b>
          </span>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8}>
          <span>
            &#9679; {`${data?.location?.districtLabel} : `}
            <b>{`${data?.location?.district || '-ไม่ระบุ-'}`}</b>
          </span>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8}>
          <span>
            &#9679; {`${data?.location?.provinceLabel} : `}
            <b>{`${data?.location?.province || '-ไม่ระบุ-'}`}</b>
          </span>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8}>
          <span>
            &#9679; {`${data?.location?.zipCodeLabel} : `}
            <b>{`${data?.location?.zipCode || '-ไม่ระบุ-'}`}</b>
          </span>
        </Col>
      </Row>
      {data?.projectPosition?.value && (
        <Row>
          <Col xs={24} sm={24} md={24} lg={24}>
            <span>
              &#9679; {`${data?.projectPosition?.label} : `}
              <b>{`${data?.projectPosition?.value || '-ไม่ระบุ-'}`}</b>
            </span>
          </Col>
        </Row>
      )}
      {data?.projectPosition?.value && (
        <>
          <br />
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <p>
                <b>{`${data?.positionExperience?.label}`}</b>
              </p>
              <span>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                {`${data?.positionExperience?.value || '-ไม่ระบุ-'}`}
              </span>
            </Col>
          </Row>
        </>
      )}
    </>
  )
}
